/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: mvpd-grid-search-view-component
 *
 * Created by rwilliams on 10/16/17.
 */
'use strict';

function MVPDGridSearchViewController(
    this: JS5Object,
    _: JS5Object,
    $location: JS5Object,
    $routeParams: JS5Object,
    uiGridConstants: JS5Object,
    PaginationService: JS5Object,
    PartnerEditService: JS5Object,
    NavbarUtilService: JS5Object,
    SearchFilterService: JS5Object,
): void {

	let processGridFilter = (renderableRows: JS5Object[]): JS5Object[] => {
		_.forEach(renderableRows, (row: JS5Object): void => {
			if (this.searchText === null || this.searchText === '') {
				row.visible = true;
			} else {
				let criteria: string = this.searchText.toLowerCase();
				row.visible = row.entity.name && row.entity.name.toLowerCase().indexOf(criteria) !== -1;
			}
		});
		return renderableRows;
	};

	let handleGridDataQuery = (gridData: JS5Object, responseHeaders: JS5Function) => {
		PaginationService.parseResponseHeaders(responseHeaders());
		PaginationService.pageData = gridData;
	};

	let navigateToMVPDPartnerSearchView = (row: JS5Object): void => {
		let searchView = $routeParams.searchView || 'networks';
		$location.url(`/meta/mvpd/edit/partner/${row.id}/${searchView}`);
	};

	let getData = (): void => {
		let criteria = {
			fetchOffset: this.pagingOptions.pageSize * (this.pagingOptions.currentPage - 1),
			fetchLimit: this.pagingOptions.pageSize,
			mvpd: true
		};
		this.loadingIndicator.show = true;
		this.searchText = $location.search().searchText || null;

		PartnerEditService.getAllPartners(criteria, handleGridDataQuery).then((partners: JS5Object[]): void => {
			this.gridOptions.data = partners;
			this.loadingIndicator.show = false;
		});
	};

	let onPaginationChanged = (): void => {
		getData();
	};

	this.executeSearch = (): void => {
		this.partnerGridApi.grid.refresh();
	};

	this.paginationPageSizeChanged = function () {
		this.pagingOptions.currentPage = 1;
		onPaginationChanged();
	};

	this.paginationPrevPageHandler = function () {
		--this.pagingOptions.currentPage;
		onPaginationChanged();
	};

	this.paginationNextPageHandler = function () {
		++this.pagingOptions.currentPage;
		onPaginationChanged();
	};

	this.onRowDblClick = (row: JS5Object) => {
		navigateToMVPDPartnerSearchView(row.entity);
	};

	this.columnDefinitions = [
		{
			field: 'name',
			displayName: 'Name',
			sort: {
				direction: 'asc',
			},
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		},
		{
			field: 'subscriptionCount',
			displayName: 'Subscriptions',
			cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
		}
	];

	this.gridOptions = {
		rowSelection: true,
		enableRowHeaderSelection: false,
		enableSelectAll: false,
		enableColumnResizing: true,
		enablePaginationControls: false,
		enableSorting: true,
		enableColumnMenus: false,
		enableFullRowSelection: true,
		enableHorizontalScrollbar: uiGridConstants.ALWAYS,
		enableVerticalScrollbar: uiGridConstants.ALWAYS,
		rowHeight: 26,
		multiSelect: false,
		columnDefs: this.columnDefinitions,
		onRegisterApi: (gridApi: JS5Object): void => {
			this.partnerGridApi = gridApi;
			this.partnerGridApi.grid.registerRowsProcessor(processGridFilter, 200);
		},
		rowTemplate: 'components/visual/grid/searchview-component-row-template.html',
		data: []
	};

	this.paginationDefs = {
		paginationPrevPageHandler: this.paginationPrevPageHandler,
		paginationNextPageHandler: this.paginationNextPageHandler,
		paginationPageSizeChanged: this.paginationPageSizeChanged,
		paginationJumpToPageHandler: onPaginationChanged,
		pagingOptions: PaginationService,
	};

	this.$onInit = () => {
		this.loadingIndicator = {
			backdrop: true,
			show: false,
			title: 'Working',
			message: 'Please wait...'
		};

		PaginationService.resetToDefaultValues();
		this.searchText = '';
		this.pagingOptions = PaginationService;
		NavbarUtilService.viewSearchFunction = getData;
        SearchFilterService.populateCriteriaFromLocationSearch();

		getData();
	};

	this.$onDestroy = (): void => {
		NavbarUtilService.viewSearchFunction = null;
	};
}

angular.module('prism-ui.mvpd').component('mvpdGridSearchView', {
	controller: MVPDGridSearchViewController,
	templateUrl: 'meta/mvpd/searchView/mvpd-grid-search-view-template.html',
	bindings: {}
});
